import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "./cn";
import { Badge } from "./badge";

export interface EmptyStateProps {
  icon?: LucideIcon;
  badge?: string;
  title: string;
  description?: string;
  cta?: ReactNode;
  meta?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon: Icon,
  badge,
  title,
  description,
  cta,
  meta,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "mx-auto flex w-full max-w-2xl flex-col items-center gap-5 rounded-xl border border-dashed border-border bg-surface-elevated/40 p-10 text-center",
        className,
      )}
    >
      {Icon && (
        <div className="flex size-14 items-center justify-center rounded-2xl bg-brand-muted text-brand">
          <Icon className="size-7" strokeWidth={1.5} />
        </div>
      )}
      {badge && (
        <Badge variant="secondary" className="uppercase tracking-wide">
          {badge}
        </Badge>
      )}
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-semibold tracking-tight text-on-surface">
          {title}
        </h2>
        {description && (
          <p className="text-sm leading-relaxed text-on-surface-muted">
            {description}
          </p>
        )}
      </div>
      {cta && <div className="flex flex-wrap items-center justify-center gap-2">{cta}</div>}
      {meta && (
        <div className="border-t border-border pt-4 text-xs text-on-surface-muted">
          {meta}
        </div>
      )}
    </div>
  );
}
